import './cookie-banner.js';
import { supabase } from './lib/supabase.js';

const form = document.getElementById('signupForm');
const errorMsg = document.getElementById('errorMsg');
const successMsg = document.getElementById('successMsg');
const submitBtn = document.getElementById('submitBtn');

// Se già loggato, vai direttamente all'app
supabase.auth.getSession().then(({ data }) => {
  if (data.session) window.location.href = '/app.html';
});

form.addEventListener('submit', async (e) => {
  e.preventDefault();
  errorMsg.classList.remove('visible');
  successMsg.classList.remove('visible');

  const email = document.getElementById('email').value.trim();
  const password = document.getElementById('password').value;
  const passwordConfirm = document.getElementById('passwordConfirm').value;

  if (password !== passwordConfirm) {
    errorMsg.textContent = 'Passwords do not match.';
    errorMsg.classList.add('visible');
    return;
  }

  submitBtn.disabled = true;
  submitBtn.textContent = 'Creating account...';

  const { error } = await supabase.auth.signUp({ email, password });

  if (error) {
    errorMsg.textContent = error.message;
    errorMsg.classList.add('visible');
    submitBtn.disabled = false;
    submitBtn.textContent = 'Create Account';
    return;
  }

  // Signup ok — redirect diretto (email confirm disabilitato in dev)
  window.location.href = '/app.html';
});
